import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const fetchPartnershipAmountDetailsTypes = getApiActionTypes(
  'FETCH_PARTNERSHIP_AMOUNT_DETAILS',
);
